import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

export function useAuth() {
  const token = localStorage.getItem('tiendaya_token');

  const { data: user, isLoading } = useQuery({
    queryKey: ['auth-user'],
    queryFn: async () => {
      if (!token) return null;

      try {
        // Intentar obtener información del usuario desde alguna API
        // Por ahora, decodificaremos la información del token o usaremos una API dedicada
        const { data } = await api.get('/api/auth/me');
        return data;
      } catch {
        // Si falla, asumimos que no está autenticado
        localStorage.removeItem('tiendaya_token');
        return null;
      }
    },
    enabled: !!token,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });

  return {
    user,
    isAuthenticated: !!user,
    isLoading,
    isMerchant: user?.user_type === 'merchant',
    isCustomer: user?.user_type === 'customer',
    token,
  };
}